export class ControlViolationsPerSeverityViolatedControlsInner {
    'id';
    'name';
    'affectedResources';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "affectedResources",
            "baseName": "affectedResources",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlViolationsPerSeverityViolatedControlsInner.attributeTypeMap;
    }
    constructor() {
    }
}
